import React, { useEffect, useState } from 'react';
import api from '../../lib/api';

/**
 * VersionHistory — timeline view of changelog + deployment memory
 * entries. Reuses /api/lab/knowledge filtered to {deployment, changelog}.
 */
export default function VersionHistory() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    Promise.all([
      api.get('/lab/knowledge?kind=deployment&limit=100'),
      api.get('/lab/knowledge?kind=changelog&limit=100'),
    ])
      .then(([a, b]) => {
        const merged = [...(a.data.entries || []), ...(b.data.entries || [])]
          .sort((x, y) => (y.timestamp || '').localeCompare(x.timestamp || ''));
        setRows(merged);
      })
      .catch(() => {});
  }, []);

  return (
    <div data-testid="lab-versions" className="space-y-2">
      {rows.length === 0 ? (
        <div className="border border-[var(--border-default)] p-4 text-[11px] text-[var(--txt-secondary)]">
          No deployment or changelog entries yet. They populate automatically as the platform evolves.
        </div>
      ) : (
        <div className="border-l-2 border-cyan-sys pl-4 space-y-3">
          {rows.map((r) => (
            <div key={r.id} data-testid={`lab-version-${r.id}`}>
              <div className="flex items-center gap-2 mb-1">
                <span className="inline-block w-2 h-2 bg-cyan-sys rounded-full -ml-5" />
                <div className="text-[10px] tracking-[0.25em] uppercase text-[var(--txt-secondary)]">
                  {r.kind} · {(r.timestamp || '').replace('T', ' ').slice(0, 19)}Z
                </div>
              </div>
              <div className="text-[12px] text-[var(--txt-primary)]">{r.title}</div>
              {r.body && <div className="text-[11px] text-[var(--txt-secondary)] mt-0.5">{r.body}</div>}
              {r.sha && <div className="text-[10px] font-mono text-cyan-sys mt-0.5">sha: {r.sha}</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
